import { TwoFactorAuthTypesApiPaths, TwoFactorAuthTypesComponents } from '@affiliate-cabinet/types'

import { resolveDomain, RestClient } from '../../../utils'

const client = new RestClient(TwoFactorAuthTypesApiPaths.PostApiAuth2faConfirm, {}, resolveDomain(), { mode: 'cors', referrerPolicy: 'no-referrer' })

export const confirmTwoFactorAuthHandler = async (data: TwoFactorAuthTypesComponents['schemas']['2FaConfirm']) => {
  await client.post<TwoFactorAuthTypesComponents['schemas']['2FaConfirm'], Response>('', data, {
    'Content-Type': 'application/json',
  })
}
